{
  "name": "justonweb",
  "version": "26.4.00",
  "license": "MIT",
  "scripts": {
    "ng": "nx",
    "nx": "nx",
    "start": "ng serve justonweb --port 4800",
    "start:login": "ng serve justonweb-login --port 4801",
    "build": "ng build",
    "build:dev": "ng build justonweb --configuration=axi-dev",
    "build-development-justice": "nx run clerk:build:axi-dev",
    "build:acc": "ng build justonweb --configuration=just-acc --aot",
    "build-login:acc": "ng build justonweb-login --configuration=just-acc --aot",
    "build:prod": "ng build justonweb --configuration=just-prod --aot",
    "build-login:prod": "ng build justonweb-login --configuration=just-prod --aot",
    "test": "ng test",
    "lint": "nx workspace-lint && ng lint",
    "e2e": "ng e2e",
    "watch-server": "ng build --watch",
    "affected:apps": "nx affected:apps",
    "affected:libs": "nx affected:libs",
    "affected:build": "nx affected:build",
    "affected:e2e": "nx affected:e2e",
    "affected:test": "nx affected:test",
    "affected:lint": "nx affected:lint",
    "affected:dep-graph": "nx affected:dep-graph",
    "affected": "nx affected",
    "format": "nx format:write",
    "format:write": "nx format:write",
    "format:check": "nx format:check",
    "update": "ng update @nrwl/workspace",
    "update:check": "ng update",
    "workspace-schematic": "nx workspace-schematic",
    "dep-graph": "nx dep-graph",
    "help": "nx help",
    "docs-generate-not-angular8": "npx compodoc -p apps/justonweb/tsconfig.app.json",
    "docs-serve-not-angular8": "npx compodoc -s apps/justonweb/tsconfig.app.json --open",
    "docs-generate-theme2": "npx compodoc -p apps/justonweb/tsconfig.base.json --theme=postmark",
    "docs-generate-theme3": "npx compodoc -p apps/justonweb/tsconfig.base.json --theme=stripe",
    "docs-generate-theme4": "npx compodoc -p apps/justonweb/tsconfig.base.json --theme=laravel",
    "docs-generate": "npx compodoc -p apps/justonweb/tsconfig.base.json --theme=vagrant",
    "docs-serve": "npx compodoc -s apps/justonweb/tsconfig.base.json --open",
    "postinstall": "node ./decorate-angular-cli.js && ngcc --properties es2015 browser module main --first-only --create-ivy-entry-points",
    "build:stats": "ng build --stats-json",
    "analyze": "webpack-bundle-analyzer dist/angular-bundle-analyzer-example/stats.json"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^19.2.18",
    "@angular/cdk": "^19.2.19",
    "@angular/common": "^19.2.18",
    "@angular/compiler": "^19.2.18",
    "@angular/core": "^19.2.18",
    "@angular/forms": "^19.2.18",
    "@angular/material": "^19.2.19",
    "@angular/material-moment-adapter": "^19.2.19",
    "@angular/platform-browser": "^19.2.18",
    "@angular/platform-browser-dynamic": "^19.2.18",
    "@angular/router": "^19.2.18",
    "@jsverse/transloco": "^7.5.0",
    "@ngxs/router-plugin": "^19.0.0",
    "@ngxs/storage-plugin": "^19.0.0",
    "@ngxs/store": "^19.0.0",
    "@nrwl/angular": "^10.4.15",
    "angularx-qrcode": "^19.0.0",
    "core-js": "^2.5.4",
    "date-fns": "^2.28.0",
    "html-to-pdfmake": "^2.5.20",
    "iban": "0.0.14",
    "immer": "^7.0.9",
    "libphonenumber-js": "^1.7.34",
    "lodash-es": "^4.17.15",
    "moment": "^2.24.0",
    "moment-timezone": "^0.5.33",
    "ng2-pdfjs-viewer": "^18.0.0",
    "ngx-cacheable": "^1.4.1",
    "ngx-currency": "^18.0.0",
    "ngx-extended-pdf-viewer": "^22.1.0-alpha.2",
    "ngx-mask": "^19.0.4",
    "ngx-moment": "^6.0.2",
    "ngx-quill": "^27.0.0",
    "pdfmake": "^0.1.68",
    "quill": "^2.0.3",
    "rxjs": "^7.8.1",
    "serialize-javascript": "^2.1.2",
    "tslib": "^1.10.0",
    "uuid": "^3.4.0",
    "zone.js": "^0.15.1"
  },
  "devDependencies": {
    "@angular/build": "^19.2.20",
    "@angular/cli": "19.2.20",
    "@angular/compiler-cli": "^19.2.18",
    "@angular/language-service": "^19.2.18",
    "@fortawesome/fontawesome-free": "^5.12.0",
    "@ngxs/devtools-plugin": "^19.0.0",
    "@nrwl/cypress": "10.4.15",
    "@nrwl/jest": "10.4.15",
    "@nrwl/workspace": "10.4.15",
    "@types/jest": "25.1.4",
    "@types/node": "^12.11.1",
    "codelyzer": "^6",
    "cypress": "^3.8.2",
    "dotenv": "6.2.0",
    "jest": "29.7.0",
    "jest-preset-angular": "8.1.3",
    "less": "^4.2.0",
    "prettier": "2.4.1",
    "ts-jest": "25.2.1",
    "ts-node": "~7.0.0",
    "tslint": "6.1.3",
    "typescript": "5.8.3",
    "webpack-bundle-analyzer": "^4.5.0"
  }
}
